import { render, staticRenderFns } from "./img-text-comment.vue?vue&type=template&id=033ea654&scoped=true&"
import script from "./img-text-comment.vue?vue&type=script&lang=js&"
export * from "./img-text-comment.vue?vue&type=script&lang=js&"
import style0 from "./img-text-comment.vue?vue&type=style&index=0&id=033ea654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ea654",
  null
  
)

export default component.exports